"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("react/jsx-runtime");

var lodash_1 = require("lodash");

var react_router_dom_1 = require("react-router-dom");

var prop_types_1 = require("prop-types");

var index_1 = require("../../index");

require("./index.css");

var MenuItem = function (_a) {
  var open = _a.open,
      setOpen = _a.setOpen,
      title = _a.title,
      label = _a.label,
      icon = _a.icon,
      iconClasses = _a.iconClasses,
      extraIcons = _a.extraIcons,
      extraIconsClasses = _a.extraIconsClasses,
      iconWidth = _a.iconWidth,
      navTarget = _a.navTarget,
      linkClass = _a.linkClass,
      activeStyle = _a.activeStyle,
      props = __rest(_a, ["open", "setOpen", "title", "label", "icon", "iconClasses", "extraIcons", "extraIconsClasses", "iconWidth", "navTarget", "linkClass", "activeStyle"]);

  var ariaLabel = label || title;
  return (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, {
    children: [(0, jsx_runtime_1.jsxs)(react_router_dom_1.NavLink, __assign({
      to: navTarget,
      "aria-label": ariaLabel,
      className: "menu-item " + linkClass,
      onClick: function () {
        if (setOpen) {
          setOpen(!open);
        }
      }
    }, props, {
      children: [(0, jsx_runtime_1.jsx)("span", __assign({
        className: "menu-item-icon"
      }, {
        children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
          name: icon,
          className: iconClasses,
          width: iconWidth
        }, void 0)
      }), void 0), (0, jsx_runtime_1.jsx)("span", __assign({
        className: "menu-item-title"
      }, {
        children: title
      }), void 0), (0, lodash_1.map)(extraIcons, function (icon, index) {
        return (0, jsx_runtime_1.jsx)("span", __assign({
          className: "menu-item-state-icon"
        }, {
          children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
            name: icon,
            className: extraIconsClasses[index] || ''
          }, void 0)
        }), void 0);
      }), (0, jsx_runtime_1.jsx)("span", __assign({
        className: "menu-item-arrow"
      }, {
        children: (0, jsx_runtime_1.jsx)(index_1.Icon, {
          name: "right-chevron",
          className: "fill icon-orange-theme",
          width: 16
        }, void 0)
      }), void 0), (0, jsx_runtime_1.jsx)("div", __assign({
        className: "menu-label"
      }, {
        children: title
      }), void 0)]
    }), void 0), (0, jsx_runtime_1.jsx)("div", {
      className: "menu-separator"
    }, void 0)]
  }, void 0);
};

MenuItem.propTypes = {
  icon: prop_types_1.string.isRequired,
  iconClasses: prop_types_1.string.isRequired,
  extraIcons: (0, prop_types_1.arrayOf)(prop_types_1.string),
  extraIconsClasses: (0, prop_types_1.arrayOf)(prop_types_1.string),
  iconWidth: prop_types_1.number,
  navTarget: prop_types_1.string.isRequired,
  title: (0, prop_types_1.oneOfType)([prop_types_1.string, prop_types_1.array]).isRequired,
  label: prop_types_1.string,
  linkClass: prop_types_1.string.isRequired
};
MenuItem.defaultProps = {
  iconWidth: 24,
  label: '',
  extraIcons: [],
  extraIconsClasses: []
};
exports.default = MenuItem;